exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wikiframe {\n  width: 100%;\n  height: 100%;\n}\n\n.collapse {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  box-sizing: border-box;\n  padding-right: 20px;\n}\n\n.collapse span {\n  font-size: 2em;\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #54a0ff;\n  border-radius: 50%;\n  color: white;\n  box-shadow: 2px 2px 6px 3px rgba(0, 0, 0, 0.15);\n  transition: background-color 0.2s, box-shadow 0.2s;\n}\n\n.collapse span:hover {\n  background-color: #2e86de;\n  box-shadow: 2px 2px 8px 5px rgba(0, 0, 0, 0.1);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Wikidiv/main.css
// module id = 808
// module chunks = 0